import { UserGroupIcon } from '@heroicons/react/24/outline';
import { ButtonHTMLAttributes } from 'react';

type MeetingParticipantsIconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label?: string;
};

export function MeetingParticipantsIconButton({
  label = 'Participantes da reunião',
  className = '',
  ...props
}: MeetingParticipantsIconButtonProps) {
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      className={`inline-flex items-center justify-center rounded-md p-1.5 text-secondary-500 transition-colors hover:bg-primary-50 hover:text-primary-600 ${className}`}
      {...props}
    >
      <UserGroupIcon className="h-5 w-5" />
    </button>
  );
}
